module.exports = __webpack_public_path__ + "img/banner1.e9acf351.jpg";